import { render } from "./InfoPraticheDossier.vue?vue&type=template&id=2ba153c4&scoped=true"
import script from "./InfoPraticheDossier.vue?vue&type=script&lang=js"
export * from "./InfoPraticheDossier.vue?vue&type=script&lang=js"

import "./InfoPraticheDossier.vue?vue&type=style&index=0&id=2ba153c4&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba153c4"]])

export default __exports__